module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header-section', {
    attrs: {
      "title": "Resources and Tools",
      "set-position": "relative",
      "load-button": true,
      "create-button": true,
      "set-width": "100"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "o-content ie p-resources-and-tools",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "o-content__mob-main-column"
  }, [_c('router-link', {
    attrs: {
      "to": '/resources-and-tools/documents'
    }
  }, [_c('h2', [_vm._v("Documents")])])], 1), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-358ea556!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources-and-tools/ResourcesAndTools.vue
// module id = 1636
// module chunks = 0